import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgInProgress = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.7778 10C17.7778 14.2955 14.2955 17.7778 10 17.7778C5.70445 17.7778 2.22222 14.2955 2.22222 10C2.22222 5.70445 5.70445 2.22222 10 2.22222C14.2955 2.22222 17.7778 5.70445 17.7778 10ZM0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10ZM7 9H5V11H7V9ZM15 9H13V11H15V9ZM9 9H11V11H9V9Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgInProgress);

export default ForwardRef;
